import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconX,
  Spinner,
} from "@touchtech/web-baselayer-ui";

import { QR_CODE_SIZES } from "@is/constants";

import QRCodeComponent from "../QRCodeComponent";
import css from "./QRCodeModal.module.css";
import useManageQRCodeModal from "./hooks/useManageQRCodeModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const QRCodeModal = ({ isOpen, onClose }: Props) => {
  const { qrCodeUrl, inProgress, t } = useManageQRCodeModal();

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose}>
      <div className={css.modalContent}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>
          {inProgress
            ? t("Please wait while creating your basket")
            : t("Scan here for quick checkout")}
        </h1>
        <div className={css.qrCodeContainer}>
          {inProgress ? (
            <div className={css.loader}>
              <Spinner className="text-display-9xl" />
            </div>
          ) : (
            <QRCodeComponent value={qrCodeUrl} size={QR_CODE_SIZES.Large} />
          )}
        </div>
        <Button
          width="full"
          className={css.closeButton}
          sizing="lg"
          onClick={onClose}
        >
          <IconX />
          {t("Close")}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default QRCodeModal;
